import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navbar: true,
    theme: '',
    logo: false,
    resources: {}
  },
  mutations: {
    'HIDE_NAVBAR': (state) => {
      state.navbar = false
    },
    'OPEN_NAVBAR': (state) => {
      state.navbar = true
    },
    'CHANGE_TEHME': (state, color) => {
      state.theme = color
    },
    'CHANGE_LOGO': (state, isShow) => {
      state.logo = isShow
    },
    'ADD_RESOURCES': (state, res) => {
      let { id, src, image, lazyload } = res
      state.resources[id] = { src, image, lazyload }
    }
  },
  actions: {
    openNavbar ({ commit }) {
      commit('OPEN_NAVBAR')
    },
    hideNavbar ({ commit }) {
      commit('HIDE_NAVBAR')
    },
    changeTheme ({ commit }, color) {
      commit('CHANGE_TEHME', color)
    },
    changeLogo ({ commit }, isShow) {
      commit('CHANGE_LOGO', isShow)
    },
    addResource ({ commit }, res) {
      commit('ADD_RESOURCES', res)
    }
  }
})
